import { render, staticRenderFns } from "./TextContent.vue?vue&type=template&id=b4369e82"
import script from "./TextContent.vue?vue&type=script&lang=js"
export * from "./TextContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports